import { useQueryClient } from '@tanstack/react-query'
import { Switch } from '@/common/ui/switch'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import useMutationUpdateOperator from '@/modules/admin/api/hooks/useMutationUpdateOperator'
import { AdminQueryKey } from '@/modules/admin/keys'
import type { OperatorDataResponse } from '../../types'

interface ToggleOperatorStatusProps {
	operator: OperatorDataResponse
}

export default function ToggleOperatorStatus({
	operator,
}: ToggleOperatorStatusProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateOperator, isPending } = useMutationUpdateOperator(
		operator.id,
	)

	const handleChange = async (checked: boolean) => {
		try {
			await updateOperator({ isActive: checked })
			queryClient.invalidateQueries({
				queryKey: [AdminQueryKey.GetOperators],
			})
			toast.success('อัปเดตสถานะสำเร็จ')
		} catch (error) {
			showErrorToast(error as Error)
		}
	}

	return (
		<Switch
			checked={operator.isActive ?? false}
			onCheckedChange={handleChange}
			disabled={isPending}
		/>
	)
}
